import { Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, NgForm, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DropDownItem } from 'app/interfaces/items/dropDownItem';
import { TranslationService } from 'app/services/api/translation/translation.service';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { DialogGeneral } from '../../../DialogGeneral';

export interface DialogTranslationsAddData {
    contextData: Array<DropDownItem>;
    languageData: Array<DropDownItem>;
}

@Component({
    selector: 'dialog-settings-translations-add',
    templateUrl: 'dialog-settings-translations-add.html',
    encapsulation: ViewEncapsulation.None,
})
export class DialogSettingsTranslationsAdd extends DialogGeneral {
    @ViewChild('ngForm') ngForm: NgForm;
    form: UntypedFormGroup;
    formEnabled = true;

    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<DialogSettingsTranslationsAdd>,
        private _formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<null>,
        public dialog: MatDialog,
        private alertsService: AlertsService,
        private translationService: TranslationService,
        @Inject(MAT_DIALOG_DATA) public data: DialogTranslationsAddData
    ) {
        super(dialogRef);
        this.initForm();
    }

    initForm() {
        this.form = this._formBuilder.group({
            contextId: new UntypedFormControl('', [Validators.required]),
            translationKey: new UntypedFormControl('', [Validators.required, Validators.pattern(/^(label_|info_|text_|error_)[_a-z]*$/)]),
            translationValue: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]),
            language: new UntypedFormControl('', [Validators.required]),
        });
    }

    onChangeContext(contextId) {
        this.form.get('contextId').setValue(contextId);
    }

    addTranslation() {
        if (this.form.invalid) {
            this.alertsService.changealertHeader(this.translationService.translate('info_form_error'));
            this.alertsService.changeAlertErrorMessage(this.translationService.translate('error_form_fill_all_fields'));
            this.alertsService.changeAlertErrorShow(true);
            this.formEnabled = true;
            this.form.enable();
            return;
        }

        this.form.markAllAsTouched();
        this.formEnabled = false;
        this.form.disable();

        this.translationService
            .createTranslation({
                translationKey: this.form.get('translationKey').value,
                translationValue: this.form.get('translationValue').value,
                contextId: this.form.get('contextId').value,
                language: this.form.get('language').value,
            })
            .subscribe((success) => {
                if (success) {
                    this.dialogRef.close();
                } else {
                    this.formEnabled = true;
                    this.form.enable();
                }
            });
    }
}
